import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { switchMap, takeUntil } from 'rxjs/operators';
import { EmailNewOrgAdd } from 'src/app/models/Emails.model';
import { EmailType } from 'src/app/models/enums/email-type.enum';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { ManagementApiService } from 'src/app/services';
import { EmailSenderService } from 'src/app/services/email-sender.service';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { ConfirmationDialogComponent } from 'src/app/shared/info-dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from 'src/app/shared/info-dialogs/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from 'src/app/shared/info-dialogs/success-dialog/success-dialog.component';
import { EncrytionDecryptionHelperService } from '../../../../../services/encrytion-decryption-helper.service';
import { OrganizationTransaction } from '../../../enums/organization-transction.enum';
import { AzureDetailsModel } from '../../../models/organization/azureDetailsModel.model';
import { Organization, organizationAddress, profileContactModel, profileContractModel } from '../../../models/organization/organization.model';
import { firstValueFrom, Subject } from 'rxjs';
import { EnvironmentService } from 'src/app/services/environment.service';
import { PermissionHierarchy } from '../../../models/organization/security-role-permission.model';
import { GlobalEmittersService } from 'src/app/services/global-emitters.service';
@Component({
    selector: 'app-azure-ad-details',
    templateUrl: './azure-ad-details.component.html',
    styleUrls: ['./azure-ad-details.component.scss'],
    standalone: false,
})
export class AzureAdDetailsComponent implements OnInit {
    @Input()
    set OrgData(value: Organization) {
        this._OrgData = value;
        if (this.activatedRoute.snapshot.paramMap.get('id')) {
            this.orgId = this.activatedRoute.snapshot.paramMap.get('id');
            this.getAzureDetailsByID(value);
            this.isDisableNext = false;
        }
    }
    get OrgData(): Organization {
        return this._OrgData;
    }
    _OrgData: Organization;
    @Output() navigateToBack = new EventEmitter<number>();
    @Output() naviagateUsers = new EventEmitter<number>();
    @Output() disableOtherTabs = new EventEmitter<boolean>();
    isSubscribe: Subject<any> = new Subject<any>();

    azureDetailForm: UntypedFormGroup;
    azureDetailData: AzureDetailsModel = {
        azureAdissuerUrl: '',
        azureAdinstance: '',
        azureAddomain: '',
        azureAdtenantId: '',
        azureAdclientId: '',
        azureAdclientSecret: '',
        azureADB2CExtensionAppClientId: '',
        azureAdcallbackPath: '',
    };

    isDisableNext: boolean = true;
    isDisableTest: boolean = false;
    isValueChange: boolean = false;
    isTestConnection: boolean = false;
    isDisableBack: boolean = false;
    isEditEnabled: boolean = false;
    isorgSaved: boolean = false;
    orgId: string;
    istenetIDShow: boolean = true;
    isclientIDShow: boolean = true;
    isclientSecretShow: boolean = true;
    organizationData: Organization; //organization get from the response
    DefaultSecurityRoles: PermissionHierarchy[];
    constructor(
        private formBuilder: UntypedFormBuilder,
        private managementApiService: ManagementApiService,
        private OrganizationDataService: OrganizationDataService,
        private activatedRoute: ActivatedRoute,
        private ngxUiLoaderService: NgxUiLoaderService,
        private cd: ChangeDetectorRef,
        private ngbModal: NgbModal,
        private user_utility: UserUtilityService,
        private router: Router,
        private emailSenderService: EmailSenderService,
        private encrytionDecryptionHelperService: EncrytionDecryptionHelperService,
        private EnvironmentService: EnvironmentService,
        private globalEmittersService: GlobalEmittersService
    ) {}

    async ngOnInit(): Promise<void> {
        this.getDefaultSecurityRoles();
        this.isValueChange = false;
        this.DefaultSecurityRoles = [];
        this.isEditEnabled = await this.user_utility.checkUserPermissionDataAndRoute('edit-organization/:id', userActions.Edit);
        this.handleSubcription();
    }

    handleSubcription() {
        this.OrganizationDataService.activeOrganizationTab.pipe(takeUntil(this.isSubscribe)).subscribe((resp) => {
            if (resp == 'AzureAD Details') {
                if (!this.activatedRoute.snapshot.paramMap.get('id')) {
                    this.initForm();
                }
            }
        });

        this.OrganizationDataService.isDisableBackButton$.pipe(takeUntil(this.isSubscribe)).subscribe((value) => {
            this.isDisableBack = value;
        });

        this.OrganizationDataService.organizationTabNext.pipe(takeUntil(this.isSubscribe)).subscribe((resp) => {
            if (resp == 'AzureAD Details') {
                this.OrganizationDataService.organizationTabNext.next(null);
                this.saveFederatedOrgDetails();
            }
        });

        this.OrganizationDataService.OrganizationTabBack.pipe(takeUntil(this.isSubscribe)).subscribe((resp) => {
            if (resp == 'AzureAD Details') {
                this.navigateBack();
            }
        });
    }

    initForm() {
        this.azureDetailForm = this.formBuilder.group({
            issuer_url: new UntypedFormControl('', [Validators.required]),
            instance: new UntypedFormControl('', [Validators.required]),
            domain: new UntypedFormControl('', [Validators.required]),
            tenetID: new UntypedFormControl('', [Validators.required]),
            clientID: new UntypedFormControl('', [Validators.required]),
            clientSecret: new UntypedFormControl('', [Validators.required]),
            b2cExtensionAppClientId: new UntypedFormControl(''),
            callBackPath: new UntypedFormControl(''),
        });
    }

    getFormValues(): AzureDetailsModel {
        let formData = new AzureDetailsModel();
        formData.azureAdissuerUrl = this.azureDetailForm.get('issuer_url').value;
        formData.azureAdinstance = this.azureDetailForm.get('instance').value;
        formData.azureAddomain = this.azureDetailForm.get('domain').value;
        formData.azureAdtenantId = this.azureDetailForm.get('tenetID').value;
        formData.azureAdclientId = this.azureDetailForm.get('clientID').value;
        formData.azureAdclientSecret = this.azureDetailForm.get('clientSecret').value;
        formData.azureADB2CExtensionAppClientId = this.azureDetailForm.get('b2cExtensionAppClientId').value;
        formData.azureAdcallbackPath = this.azureDetailForm.get('callBackPath').value;
        return formData;
    }

    testConnection() {
        if (!this.azureDetailForm.invalid) {
            this.azureDetailData = this.getFormValues();
            this.ngxUiLoaderService.start();
            //Encrypt Keys
            this.azureDetailData.azureAdtenantId = this.encrytionDecryptionHelperService.encrypt(
                String(this.azureDetailData.azureAdtenantId),
                this.EnvironmentService.getConfig().azureEncKey
            );
            this.azureDetailData.azureAdclientId = this.encrytionDecryptionHelperService.encrypt(
                String(this.azureDetailData.azureAdclientId),
                this.EnvironmentService.getConfig().azureEncKey
            );
            this.azureDetailData.azureAdclientSecret = this.encrytionDecryptionHelperService.encrypt(
                String(this.azureDetailData.azureAdclientSecret),
                this.EnvironmentService.getConfig().azureEncKey
            );
            //End
            this.managementApiService.testAzureADConnection(this.azureDetailData).subscribe(
                (response) => {
                    if (response.success === true) {
                        this.ngxUiLoaderService.stop();
                        this.isDisableNext = false;
                        this.isDisableTest = true;
                        this.isTestConnection = true;
                        let dialogRef = this.ngbModal.open(SuccessDialogComponent, {
                            size: 'sm',
                        });
                        dialogRef.componentInstance.message = 'Connection Successful!';
                        this.isValueChange = false;
                        this.cd.detectChanges();
                    } else {
                        this.isDisableTest = false;
                        this.ngxUiLoaderService.stop();
                        this.user_utility.errorModelPopup('AzureB2C connection unsuccessful!');
                    }
                },
                (error) => {
                    this.isDisableTest = false;
                    this.ngxUiLoaderService.stop();
                    let dialogRef = this.ngbModal.open(ErrorDialogComponent, {
                        size: 'sm',
                    });
                    dialogRef.componentInstance.message = 'AzureB2C connection unsuccessful!';
                }
            );
        }
    }

    createFormBody() {
        // this for removing the already appended keys from the formData object
        let azureDetailsList = [
            'AzureADIssuerUrl',
            'AzureADInstance',
            'AzureADDomain',
            'AzureADTenantID',
            'AzureADClientID',
            'AzureADClientSecret',
            'AzureADB2CExtensionAppClientID',
            'AzureADCallbackPath',
            'IsFederated',
        ];
        azureDetailsList.forEach((item) => {
            if (this.OrganizationDataService.formData.has(`organisation[${item}]`)) {
                this.OrganizationDataService.formData.delete(`organisation[${item}]`);
            }
        });
        //Encrypt Keys
        let azureAdtenantId = this.encrytionDecryptionHelperService.encrypt(
            String(this.azureDetailData.azureAdtenantId),
            this.EnvironmentService.getConfig().azureEncKey
        );
        let azureAdclientId = this.encrytionDecryptionHelperService.encrypt(
            String(this.azureDetailData.azureAdclientId),
            this.EnvironmentService.getConfig().azureEncKey
        );
        let azureAdclientSecret = this.encrytionDecryptionHelperService.encrypt(
            String(this.azureDetailData.azureAdclientSecret),
            this.EnvironmentService.getConfig().azureEncKey
        );
        //End
        let formData = new FormData();
        formData.append('organisation[AzureADIssuerUrl]', this.azureDetailData.azureAdissuerUrl);
        formData.append('organisation[AzureADInstance]', this.azureDetailData.azureAdinstance);
        formData.append('organisation[AzureADDomain]', this.azureDetailData.azureAddomain);
        formData.append('organisation[AzureADTenantID]', azureAdtenantId);
        formData.append('organisation[AzureADClientID]', azureAdclientId);
        formData.append('organisation[AzureADClientSecret]', azureAdclientSecret);
        formData.append('organisation[AzureADB2CExtensionAppClientID]', this.azureDetailData.azureADB2CExtensionAppClientId);
        formData.append('organisation[AzureADCallbackPath]', this.azureDetailData.azureAdcallbackPath);
        formData.append('organisation[IsFederated]', true as unknown as Blob);

        if (this.OrganizationDataService.addOrganizationFrom.value.organization_name) {
            formData.append('organisation[Name]', this.OrganizationDataService.addOrganizationFrom.value.organization_name);
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.number_of_iDMS_licenses) {
            formData.append(
                'organisation[LicenseLimitiDMS]',
                this.OrganizationDataService.addOrganizationFrom.value.number_of_iDMS_licenses as unknown as Blob
            );
        }

        if (this.OrganizationDataService.addOrganizationFrom.value.number_of_instances) {
            formData.append('organisation[InstanceLimit]', this.OrganizationDataService.addOrganizationFrom.value.number_of_instances as unknown as Blob);
        }

        if (this.OrganizationDataService.addOrganizationFrom.value.number_of_ICE_licenses) {
            formData.append('organisation[LicenseLimitICE]', this.OrganizationDataService.addOrganizationFrom.value.number_of_ICE_licenses as unknown as Blob);
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.sfdc_customer_number) {
            formData.append('organisation[SFDCCustomerNumber]', this.OrganizationDataService.addOrganizationFrom.value.sfdc_customer_number);
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.contract_holder_name) {
            formData.append('organisation[ProfileContract][Name]', this.OrganizationDataService.addOrganizationFrom.value.contract_holder_name);
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.organization_description) {
            formData.append('organisation[ProfileContract][Description]', this.OrganizationDataService.addOrganizationFrom.value.organization_description);
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.start_date) {
            formData.append('organisation[ProfileContract][StartDate]', this.OrganizationDataService.addOrganizationFrom.value.start_date.toDateString());
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.end_date) {
            formData.append('organisation[ProfileContract][EndDate]', this.OrganizationDataService.addOrganizationFrom.value.end_date.toDateString());
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.contact_holder_first_name) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][FirstName]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_first_name
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.contact_holder_last_name) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][LastName]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_last_name
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.contact_holder_job_title) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][JobTitle]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_job_title
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.contact_holder_telephone) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][Telephone]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_telephone
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value.contact_holder_email) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][Email]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_email
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value?.contact_holder_address_line1) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][Address][Line1]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_address_line1
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value?.contact_holder_address_line2) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][Address][Line2]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_address_line2
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value?.contact_holder_city) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][Address][City]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_city
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value?.contact_holder_state) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][Address][State]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_state
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value?.contact_holder_country) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][Address][Country]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_country
            );
        }
        if (this.OrganizationDataService.addOrganizationFrom.value?.contact_holder_zipcode) {
            formData.append(
                'organisation[ProfileContract][ProfileContact][Address][Zipcode]',
                this.OrganizationDataService.addOrganizationFrom.value.contact_holder_zipcode
            );
        }
        // if (this.organizationData?.organisationId) {
        //     if (this.OrganizationDataService.addOrganizationFrom.value?.organisationId)
        //         formData.append('organisation[OrganisationId]', this.OrganizationDataService.addOrganizationFrom.value.organisationId);
        //     if (this.OrganizationDataService.addOrganizationFrom.value?.profileContractId)
        //         formData.append('organisation[ProfileContract][ProfileContractId]', this.OrganizationDataService.addOrganizationFrom.value.profileContractId);
        //     if (this.OrganizationDataService.addOrganizationFrom.value?.profileContactId)
        //         formData.append(
        //             'organisation[ProfileContract][ProfileContact][ProfileContactId]',
        //             this.OrganizationDataService.addOrganizationFrom.value.profileContactId
        //         );
        //     if (this.OrganizationDataService.addOrganizationFrom.value?.addressId)
        //         formData.append(
        //             'organisation[ProfileContract][ProfileContact][Address][AddressId]',
        //             this.OrganizationDataService.addOrganizationFrom.value.addressId
        //         );
        //     // this.formData.append('organisation[IsFederated]',body.isFedrated as unknown as Blob);
        // }
        this.OrganizationDataService.formData = formData;
    }

    saveFederatedOrgDetails() {
        let transactionType = -1;
        if (!this.azureDetailForm.invalid) {
            if (
                (this.activatedRoute.snapshot.paramMap.get('id') && this.azureDetailForm.dirty && this.isTestConnection) ||
                (this.orgId && this.azureDetailForm.dirty && this.isTestConnection) ||
                (this.OrganizationDataService?.organizationData?.organisationId && this.azureDetailForm.dirty && this.isTestConnection)
            ) {
                transactionType = OrganizationTransaction.update;
            } else if (
                !this.activatedRoute.snapshot.paramMap.get('id') &&
                this.azureDetailForm.dirty &&
                this.isTestConnection &&
                !this.orgId &&
                !this.OrganizationDataService?.organizationData?.organisationId
            ) {
                transactionType = OrganizationTransaction.add;
            } else if (this.azureDetailForm.dirty && !this.isTestConnection) {
                this.user_utility.errorModelPopup('Please test the connection before proceeding to next step.');
                return;
            } else {
                transactionType = OrganizationTransaction.navigate;
            }
        }

        switch (transactionType) {
            case OrganizationTransaction.add:
                this.ngxUiLoaderService.start();
                this.azureDetailData = this.getFormValues();
                this.createFormBody();

                let body = this.OrganizationDataService.formData;

                this.OrganizationDataService.isFederatedOrganization$.next(true);
                // changing update call add call when org details with ad details added
                this.managementApiService.addOrganization(body).subscribe(
                    async (response) => {
                        if (response.success === true) {
                            this.ngxUiLoaderService.stop();

                            this.managementApiService.addSecurityRole(response.response.organisationId, this.DefaultSecurityRoles).subscribe(
                                async (res) => {
                                    if (res.success === true) {
                                        this.ngxUiLoaderService.stop();
                                        this.globalEmittersService.currentOrganization.next(response.response); // * used for manage security roles based on license number
                                        this.OrganizationDataService.instanceLimit.next(response.response.instanceLimit);
                                        this.OrganizationDataService.organizationData = response.response;
                                        this.OrganizationDataService.currentOrgId = response.response.organisationId;
                                        this.OrganizationDataService.organizationID.next(response.response.organisationId);
                                        this.OrganizationDataService.navigateThroughWizard.next(2);
                                        this.isTestConnection = false;
                                        this.isorgSaved = true;
                                        this.organizationData = response.response; //assign org response to variable
                                        // ENABLE the other tabs
                                        this.OrganizationDataService.isDisableUserTypeWizard.next(false);
                                        this.OrganizationDataService.isDisableUsersWizard.next(true); //set to true
                                        this.OrganizationDataService.isDisableInstanceWizard.next(true); //set to true
                                        this.OrganizationDataService.isDisableOrgTab$.next(true); //set to true
                                        this.OrganizationDataService.isDisableAzureDetailWizard.next(true);

                                        this.OrganizationDataService.currentOrganizationName.next(response.response.name);
                                        this.globalEmittersService.currentOrg.next(response.response.name);
                                        this.globalEmittersService.currentOrgId.next(response.response.organisationId);
                                        this.OrganizationDataService.currentOrgId = response.response.organisationId;
                                        this.OrganizationDataService.currentOrg = response.response.name;
                                        localStorage.setItem('selectedOrganizationName', response.response.name);
                                        localStorage.setItem('selectedOrgId', response.response.organisationId);
                                        localStorage.setItem('selectedOrganization', JSON.stringify(response.response));
                                        // removing the current instance stored in local storage because each organization has different instances
                                        // on selection on new organization previously selected have to removed
                                        if (localStorage.getItem('currentInstanceName')) {
                                            localStorage.removeItem('currentInstanceName');
                                            localStorage.removeItem('currentInstanceId');
                                            this.globalEmittersService.currentInstanceName.next(null);
                                        }
                                        //ENABLE the back button
                                        this.OrganizationDataService.isDisableBackButton$.next(false);

                                        this.OrganizationDataService.isFedOrg = true;
                                        //await this.addDefaultSecurityRoles(); // * adding default roles // adding defualt secirity roles
                                        this.gettingOrgDetails(response.response.organisationId); // * getting Org details
                                        this.triggerEmail();
                                        this.cd.detectChanges();
                                    } else {
                                        this.ngxUiLoaderService.stop();
                                        this.OrganizationDataService.isDisableBackButton$.next(false); //ENABLE the back button
                                        this.user_utility.errorModelPopup(response.message);
                                    }
                                },
                                (error) => {
                                    this.ngxUiLoaderService.stop();
                                    this.user_utility.errorModelPopup('Something bad happened!! Please contact your administrator for assistance.');
                                    // TODO toast with a error message
                                }
                            );

                            // this.OrganizationDataService.instanceLimit.next(response.response.instanceLimit);
                            // this.OrganizationDataService.organizationData = response.response;
                            // this.OrganizationDataService.currentOrgId = response.response.organisationId;
                            // this.OrganizationDataService.organizationID.next(response.response.organisationId);
                            // this.OrganizationDataService.navigateThroughWizard.next(2);
                            // this.isTestConnection = false;
                            // this.isorgSaved = true;
                            // this.organizationData = response.response; //assign org response to variable
                            // // ENABLE the other tabs
                            // this.OrganizationDataService.isDisableUserTypeWizard.next(false);
                            // this.OrganizationDataService.isDisableUsersWizard.next(true); //set to true
                            // this.OrganizationDataService.isDisableInstanceWizard.next(true); //set to true
                            // this.OrganizationDataService.isDisableOrgTab$.next(true); //set to true
                            // this.OrganizationDataService.isDisableAzureDetailWizard.next(true);
                            // //ENABLE the back button
                            // this.OrganizationDataService.isDisableBackButton$.next(false);

                            // this.OrganizationDataService.isFedOrg = true;
                            // await this.addDefaultSecurityRoles(); // * adding default roles // adding defualt secirity roles
                            // this.gettingOrgDetails(response.response.organisationId); // * getting Org details
                            // this.triggerEmail();
                        } else {
                            this.ngxUiLoaderService.stop();
                            this.OrganizationDataService.isDisableBackButton$.next(false); //ENABLE the back button
                            this.user_utility.errorModelPopup(response.message);
                        }
                    },
                    (error) => {
                        this.ngxUiLoaderService.stop();
                        this.user_utility.errorModelPopup('Something bad happened!! Please contact your administrator for assistance.');
                        // TODO toast with a error message
                    }
                );

                break;

            case OrganizationTransaction.update:
                this.azureDetailData = this.getFormValues();
                this.createFormBody();
                if (!this.OrganizationDataService.formData.has('organisation[OrganisationId]')) {
                    this.OrganizationDataService.formData.append(
                        'organisation[OrganisationId]',
                        this.OrganizationDataService?.organizationData?.organisationId
                    );
                }
                if (!this.OrganizationDataService.formData.has('organisation[ProfileContract][ProfileContractId]')) {
                    this.OrganizationDataService.formData.append(
                        'organisation[ProfileContract][ProfileContractId]',
                        this.OrganizationDataService?.organizationData?.profileContract?.profileContractId
                    );
                }
                if (!this.OrganizationDataService.formData.has('organisation[ProfileContract][ProfileContact][ProfileContactId]')) {
                    this.OrganizationDataService.formData.append(
                        'organisation[ProfileContract][ProfileContact][ProfileContactId]',
                        this.OrganizationDataService?.organizationData?.profileContract?.profileContact?.profileContactId
                    );
                }
                if (!this.OrganizationDataService.formData.has('organisation[ProfileContract][ProfileContact][Address][AddressId]')) {
                    this.OrganizationDataService.formData.append(
                        'organisation[ProfileContract][ProfileContact][Address][AddressId]',
                        this.OrganizationDataService?.organizationData?.profileContract?.profileContact?.address?.addressId
                    );
                }
                let updatebody = this.OrganizationDataService.formData;

                this.OrganizationDataService.isFederatedOrganization$.next(true);
                this.ngxUiLoaderService.start();
                this.managementApiService.updateOrganization(updatebody).subscribe(
                    (response) => {
                        if (response.success === true) {
                            this.ngxUiLoaderService.stop();
                            this.getOrgDetailsByID(this.OrganizationDataService?.organizationData?.organisationId);

                            // this.gettingOrgDetails(response.response.organisationId);
                        } else {
                            this.ngxUiLoaderService.stop();
                            this.user_utility.errorModelPopup(response.message);
                        }
                    },
                    (error) => {
                        this.ngxUiLoaderService.stop();
                        this.user_utility.errorModelPopup('Something bad happened!! Please contact your administrator for assistance.');
                        // TODO toast with a error message
                    }
                );

                break;

            case OrganizationTransaction.navigate:
                this.OrganizationDataService.isDisableUserTypeWizard.next(false);
                this.OrganizationDataService.isDisableUsersWizard.next(true); //set to true
                this.OrganizationDataService.isDisableInstanceWizard.next(true); //set to true
                this.OrganizationDataService.isDisableOrgTab$.next(true); //set to true
                this.OrganizationDataService.isDisableAzureDetailWizard.next(true);
                this.OrganizationDataService.navigateThroughWizard.next(2);
                break;
            case OrganizationTransaction.testConnection:
                this.testConnection();
                this.isValueChange = false;
                break;
        }
    }

    initEditFedratedDetails() {
        this.azureDetailForm = this.formBuilder.group({
            issuer_url: new UntypedFormControl(this.azureDetailData.azureAdissuerUrl, [Validators.required]),
            instance: new UntypedFormControl(this.azureDetailData.azureAdinstance, [Validators.required]),
            domain: new UntypedFormControl(this.azureDetailData.azureAddomain, [Validators.required]),
            tenetID: new UntypedFormControl(
                this.encrytionDecryptionHelperService.decrypt(this.azureDetailData.azureAdtenantId, this.EnvironmentService.getConfig().azureEncKey),
                [Validators.required]
            ),
            clientID: new UntypedFormControl(
                this.encrytionDecryptionHelperService.decrypt(this.azureDetailData.azureAdclientId, this.EnvironmentService.getConfig().azureEncKey),
                [Validators.required]
            ),
            clientSecret: new UntypedFormControl(
                this.encrytionDecryptionHelperService.decrypt(this.azureDetailData.azureAdclientSecret, this.EnvironmentService.getConfig().azureEncKey),
                [Validators.required]
            ),
            b2cExtensionAppClientId: new UntypedFormControl(
                !this.azureDetailData.azureADB2CExtensionAppClientId || this.azureDetailData.azureADB2CExtensionAppClientId == 'null'
                    ? ''
                    : this.azureDetailData.azureADB2CExtensionAppClientId,
                []
            ),
            callBackPath: new UntypedFormControl(
                !this.azureDetailData.azureAdcallbackPath || this.azureDetailData.azureAdcallbackPath == 'null' ? '' : this.azureDetailData.azureAdcallbackPath,
                []
            ),
        });
    }

    getAzureDetailsByID(data) {
        this.OrganizationDataService.instanceLimit.next(data.instanceLimit);
        this.azureDetailData.azureAdissuerUrl = data.azureADIssuerUrl;
        this.azureDetailData.azureAdinstance = data.azureADInstance;
        this.azureDetailData.azureAddomain = data.azureADDomain;
        this.azureDetailData.azureAdtenantId = this.azureDetailData.azureAdtenantId;
        this.azureDetailData.azureAdtenantId = data.azureADTenantId;
        this.azureDetailData.azureAdclientId = data.azureADClientId;
        this.azureDetailData.azureAdclientSecret = data.azureADClientSecret;
        this.azureDetailData.azureAdcallbackPath = data.azureADCallbackPath;
        this.initEditFedratedDetails();
        this.isDisableTest = true;
    }

    getOrgDetailsByID(id: string) {
        this.managementApiService.getOrganizationById(id).subscribe((response) => {
            if (response.success === true) {
                this.OrganizationDataService.organizationData = response.response;
                this.OrganizationDataService.currentOrgId = response.response.organisationId;
                this.OrganizationDataService.organizationID.next(response.response.organisationId);
                this.organizationData = response.response; //assign org response to variable
                this.OrganizationDataService.navigateThroughWizard.next(2);
                this.isTestConnection = false;
                this.isorgSaved = true;
                // ENABLE the other tabs
                this.OrganizationDataService.isDisableUserTypeWizard.next(false);
                this.OrganizationDataService.isDisableUsersWizard.next(true); //set to true
                this.OrganizationDataService.isDisableInstanceWizard.next(true); //set to true
                this.OrganizationDataService.isDisableOrgTab$.next(true); //set to true
                this.OrganizationDataService.isDisableAzureDetailWizard.next(true);
                //ENABLE the back button
                this.OrganizationDataService.isDisableBackButton$.next(false);

                this.OrganizationDataService.isFedOrg = true;
                this.globalEmittersService.currentOrganization.next(response.response); // * used for manage security roles based on license number
            } else {
                this.user_utility.errorModelPopup(response.message);
            }
        });
    }

    detectValueChange(event) {
        this.isDisableNext = true;
        this.isDisableTest = false;
        this.isValueChange = true;
        this.isTestConnection = false;
        this.disableOtherTabs.emit(true);
        // DISABLE the other tabs
        this.OrganizationDataService.isDisableUserTypeWizard.next(true);
        this.OrganizationDataService.isDisableUsersWizard.next(true);
        this.OrganizationDataService.isDisableInstanceWizard.next(true);
        this.OrganizationDataService.isDisableOrgTab$.next(true);
        // DISABLE the back button
        // this.OrganizationDataService.isDisableBackButton$.next(true);
    }

    navigateBack() {
        //  this.navigateToBack.emit(0);
        this.OrganizationDataService.isDisableAzureDetailWizard.next(true);
        this.OrganizationDataService.isDisableOrgTab$.next(false);
        this.OrganizationDataService.navigateThroughWizard.next(0);
    }

    // * api call to add the user security roles
    getDefaultSecurityRoles() {
        // this.managementApiService
        //     .getSecurityRolesPermissionTemplate(true)
        //     .pipe(
        //         switchMap((res) => {
        //             if (res.success) {
        //                 this.DefaultSecurityRoles = res.response;
        //                 return this.managementApiService.addSecurityRole(this.organizationData.organisationId, res.response);
        //             } else if (res.isCustom) {
        //                 this.user_utility.errorModelPopup(res.message);
        //                 this.ngxUiLoaderService.stop();
        //             }
        //         })
        //     )
        //     .toPromise()
        //     .catch((error) => {
        //         this.ngxUiLoaderService.stop();
        //     });

        this.managementApiService.getSecurityRolesPermissionTemplate(true).subscribe((response) => {
            if (response.success === true) {
                this.DefaultSecurityRoles = response.response;
            } else {
                this.DefaultSecurityRoles = [];
                this.user_utility.errorModelPopup(response.message);
            }
        });
    }
    gettingOrgDetails(organisationId) {
        this.managementApiService.getOrganizationById(organisationId).subscribe((response) => {
            if (response.success === true) {
                this.orgId = response.response.organisationId;
                this.OrganizationDataService.organizationData = response.response;
            } else {
                this.user_utility.errorModelPopup(response.message);
            }
        });
    }

    //When Clicking on cancel button this event is fired
    clickCancel() {
        if (this.isorgSaved === false || this.azureDetailForm.dirty) {
            let dialogRef = this.ngbModal.open(ConfirmationDialogComponent, {
                size: 'sm',
            });
            if (this.orgId) {
                dialogRef.componentInstance.modalMessage = 'Your changes are not saved. Are you sure you want to go back?';
            } else {
                dialogRef.componentInstance.modalMessage = 'Your Organization is not saved. Are you sure you want to go back?';
            }
            dialogRef.result
                .then((result) => {
                    if (result === true) {
                        this.router.navigate(['/management/organization']);
                    }
                })
                .catch((e) => {
                    console.warn(e);
                });
        } else {
            this.router.navigate(['/management/organization']);
        }
    }

    // * helper method to trigger an email
    triggerEmail() {
        let payload = new EmailNewOrgAdd();
        payload.lastName = this.organizationData.profileContract.profileContact?.lastName;
        payload.firstName = this.organizationData.profileContract.profileContact.firstName
            ? this.organizationData.profileContract.profileContact.firstName
            : '';
        payload.email = this.organizationData.profileContract.profileContact.email;
        payload.organizationName = this.organizationData.name;
        this.emailSenderService.emailHandler(EmailType.NewOrgAdded, [this.organizationData.profileContract.profileContact.email], payload).subscribe(
            (res) => {
                if (res.success) {
                    // TODO Email sent successfully
                }
            },
            (err) => {
                // TODO Error while sending the email
            }
        );
    }

    ngOnDestroy(): void {
        this.isSubscribe.next(null);
        this.isSubscribe.complete();
    }
}
